import CASL from '@/utils/constants/casl'

export default {
  path: 'status-kwh',
  children: [
    {
      path: '',
      name: 'input-no-registrasi.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.STATUS_KWH
      },
      component: () => import('./list/InputNoRegistrasiListPage.vue')
    },
    {
      path: ':uid',
      name: 'input-no-registrasi.detail',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.STATUS_KWH
      },
      component: () => import('./form/InputNoRegistrasiFormPage.vue')
    }
  ]
}
